module.exports = __webpack_public_path__ + "static/img/pingjieshen3.f39f052f.png";